import { UserManagementScreen } from "@/screens";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  page: z.number().optional(),
  pageSize: z.number().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.string().optional(),
  name: z.string().optional(),
  role: z.string().optional(),
  createdAt: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/dashboard/users/")({
  component: UserManagementScreen,
  validateSearch: (search) => searchSchema.parse(search),
  loaderDeps: ({ search }) => ({
    role: search.role,
    createdAt: search.createdAt,
    page: search.page,
    pageSize: search.pageSize,
    sortBy: search.sortBy,
    sortOrder: search.sortOrder,
    status: search.status,
  }),
  loader: async () => {
    return {
      crumb: "Manajemen User",
    };
  },
});
